module.exports = __webpack_public_path__ + "static/media/kodflix-movie.0fc6195f.jpg";